module.exports = __webpack_public_path__ + "assets/img/1_1735.42dc2d50.jpg";